import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
//import Imagen1 from "../../../images/modulo12/damacao.png";
//import Imagen2 from "../../../images/modulo12/convento.png";
import Modulo12U3Act3 from "../../../DnD/modulo12U3Act3";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad3Actividad3.mp3";

const Actividad5 = () => {
  const infoUnidad = modulo12.content[2];
  const infoAct = modulo12.content[2].activities[3];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo12.content[2].name}: ${modulo12.content[2].activities[4].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[4].path}`,
    titlePrev: `${modulo12.content[2].name}: ${modulo12.content[2].activities[2].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[2].path}`,
  };

  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  const items = [
    <div className="selectable btn btn-red shadow mx-3 my-1">Machismo</div>,
    <div className="selectable btn btn-red shadow mx-3 my-1">Oportunidad</div>,
    <div className="selectable btn btn-red shadow mx-3 my-1">Equidad</div>,
  ];

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul className="mb-4">
        <li>Arrastra las palabras hacia el recuadro con la definición que les corresponde. </li>
        <li>Luego encuentra las palabras en el pupiletras.</li>
      </ul>
      <Modulo12U3Act3 items={items} />
      <table className="table table-bordered text-center mt-5">
        <tbody>
          <tr>
            <td>S</td>
            <td>E</td>
            <td>M</td>
            <td>T</td>
            <td>D</td>
            <td>O</td>
            <td>M</td>
            <td>S</td>
            <td>D</td>
            <td>C</td>
            <td>G</td>
          </tr>
          <tr>
            <td>A</td>
            <td>Q</td>
            <td>E</td>
            <td>A</td>
            <td>O</td>
            <td>R</td>
            <td>I</td>
            <td>E</td>
            <td>C</td>
            <td>A</td>
            <td>E</td>
          </tr>
          <tr>
            <td>L</td>
            <td>U</td>
            <td>I</td>
            <td>S</td>
            <td>M</td>
            <td>E</td>
            <td>N</td>
            <td>U</td>
            <td>S</td>
            <td>X</td>
            <td>N</td>
          </tr>
          <tr>
            <td>E</td>
            <td>I</td>
            <td>A</td>
            <td>M</td>
            <td>I</td>
            <td>U</td>
            <td>R</td>
            <td>I</td>
            <td>F</td>
            <td>R</td>
            <td>E</td>
          </tr>
          <tr>
            <td>T</td>
            <td>D</td>
            <td>S</td>
            <td>E</td>
            <td>N</td>
            <td>L</td>
            <td>M</td>
            <td>P</td>
            <td>D</td>
            <td>E</td>
            <td>R</td>
          </tr>
          <tr>
            <td>M</td>
            <td>A</td>
            <td>C</td>
            <td>H</td>
            <td>I</td>
            <td>S</td>
            <td>M</td>
            <td>O</td>
            <td>E</td>
            <td>F</td>
            <td>O</td>
          </tr>
          <tr>
            <td>N</td>
            <td>D</td>
            <td>N</td>
            <td>L</td>
            <td>O</td>
            <td>R</td>
            <td>A</td>
            <td>C</td>
            <td>R</td>
            <td>G</td>
            <td>S</td>
          </tr>
          <tr>
            <td>O</td>
            <td>P</td>
            <td>O</td>
            <td>R</td>
            <td>T</td>
            <td>U</td>
            <td>N</td>
            <td>I</td>
            <td>D</td>
            <td>A</td>
            <td>D</td>
          </tr>
        </tbody>
      </table>

      <GuiaDocente>
        <ul>
          <li>
            Explique a niños y niñas que aprenderán palabras nuevas asociadas
            a la desigualdad entre hombres y mujeres. Específicamente,
            trabajarán con las palabras “machismo”, “oportunidad”, “equidad”,
            “rechazo”, “obstáculo”, “superación” y “logro”.
          </li>
          <li>
            Lea la indicación: Arrastra las palabras hacia el recuadro con la definición que les corresponde. Déles un tiempo para trabajar individualmente y
            luego revisen conjuntamente las respuestas.
          </li>
          <li>
            Lea la siguiente indicación: Luego encuentra las palabras en el
            pupiletras. Déles a niños y niñas un tiempo para que ubiquen las
            palabras y luego revisen. Confirme que los niños y niñas han
            comprendido el significado de las palabras. Pídales que elaboren una
            oración con cada una ellas o que den un ejemplo.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad5;
